import { Injectable } from '@angular/core';

declare var window;

@Injectable()
export class BaseServiceExceptionHandler {
	constructor() {
	}

	private performErrorAction(err: any) {
		if (window._errorHandlingComponent && window._errorHandlingComponent.onUnhandledError ) {
			window._errorHandlingComponent.onUnhandledError(
				{
					type: "UNKNOWN_SERVICE_ERROR"
				}
			);
		}
	}

	public handleError(err: any, exceptionHandlers: Array<string>) {
		if (err.status != 200) {
			if (err.status == 502 || err.status == 404) {
				// Proxy error, usually means request took too long
				// TODO: fix the root problem, this is just a temporary measure
				this.performErrorAction(err);
				return;
			}

			let useDefaultHandler: boolean = true;

			if (err._body) {
				try {
					err.data = JSON.parse(err._body);

					if (err.data.exceptionName) {
						let handlerFound: boolean = false;
						if ( exceptionHandlers ) {
							exceptionHandlers.forEach(function(handler) {
								if (handler === err.data.exceptionName) {
									handlerFound = true;
								}
							});

							useDefaultHandler = !handlerFound;
						}
					} else if (err.data.errorCode && err.data.cause) {
						useDefaultHandler = false;
					} else {
						useDefaultHandler = true;
					}
				} catch (error) {
					useDefaultHandler = true;
				}
			} else {
				useDefaultHandler = true;
			}

			if (useDefaultHandler) {
				this.performErrorAction(err);
			}
		}
	}
}
